import React from 'react';
import HomeLogic from './HomeLogic';
/**
 * Display for Home components.
 * @return {HomeLogic}
 */
const HomePage = () => {
  return (
    <HomeLogic/>
  );
};

export default HomePage;
